export const GURU_PRAKTIK_KINERJA_INDIKATOR_IMAGE: Record<string, string> = {
  'Keteraturan Suasana Kelas': 'img-chalk-board-teach-character-stundet.png',
  'Penerapan Disiplin Positif': 'img-flow-process.png',
  'Ekspektasi pada Murid': 'img-book-rapor-graphic.png',
  'Perhatian dan Kepedulian': 'img-heart-empathic-give.png',
  'Umpan Balik Konstruktif': 'img-chat-talk.png',
  'Aktivitas Interaktif': 'img-curation-cards-screen.png',
  'Instruksi yang Adaptif': 'img-assessment-subject-book.png',
  'Instruksi Pembelajaran': 'img-chalk-board.png',
}
